const getUrlParameter = (parameter: string) => {
  const urlStr = window.location.href;
  const url = new URL(urlStr);
  const urlParams = url.searchParams;

  return urlParams.get(parameter) || '0';
};

export default getUrlParameter;
